var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoordiante(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_5106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 23H18.0127",
    stroke: "#0277AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.519 9.5095C20.519 16.943 12.2595 22.7247 12.2595 22.7247C12.2595 22.7247 4 16.943 4 9.5095C4 7.31894 4.87019 5.21811 6.41915 3.66915C7.96811 2.12019 10.0689 1.25 12.2595 1.25C14.4501 1.25 16.5509 2.12019 18.0998 3.66915C19.6488 5.21811 20.519 7.31894 20.519 9.5095V9.5095Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "#0277AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3038 12.8133C14.1284 12.8133 15.6076 11.3341 15.6076 9.50949C15.6076 7.68485 14.1284 6.20569 12.3038 6.20569C10.4792 6.20569 9 7.68485 9 9.50949C9 11.3341 10.4792 12.8133 12.3038 12.8133Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "#0277AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_5106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordiante);
export default __webpack_public_path__ + "static/media/coordiante.cdf99a2681040b7ed7c678eebad25334.svg";
export { ForwardRef as ReactComponent };